import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { TextField } from "@mui/material";
import { Button, Modal, Col, Row, Form, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAccount from "../../../../core/api/api.account";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import SwalMessage from "../../_Components/SwalMessage";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { NumericFormat, PatternFormat } from "react-number-format";

// moment.locale("fa");
// moment.loadPersian();

export const NewAgentAccountModal = ({
  showModalAccount,
  setShowModalAccount,
  selectedAccountId,
}) => {
  let location = useLocation();
  let navigate = useNavigate();

  let handleClose = (e) => {
    // console.log("e ",e)
    //e.stopPropagation();
    //navigate(-1);
    //props.callback();
    setShowModalAccount(false);
  };
  // const { match } = props;
  // let params = match.params;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});

  const [listData, setListData] = useState([]);
  const [riallBalance, setRiallBalance] = useState(0);
  const [allAgentList, setAllAgentList] = useState([]);
  const [allCommisionList, setAllCommisionList] = useState([]);
  const [locationS, setlocationS] = useState(location?.state?.promoCodeId);
  const [accounts, setAccounts] = useState();
  const [copySuccess, setCopySuccess] = useState(null);
  const [promoCodeActive, setPromoCodeActive] = useState(false);
  const [selectDatePicker, setSelectDatePicker] = useState();
  const [promoCodeSelectedReadOnly, setpromoCodeSelectedReadOnly] =
    useState(false);
  const [statusEditField, setstatusEditField] = useState(false);
  //   const dataForm = {
  //     rialAmount: register("rialAmount", { required: true }),
  //     accountId: register("accountId", { required: true }),
  // }

  useEffect(() => {
    (async () => {
      try {
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => {};
  }, []);

  const onSubmit = async (data) => {
    try {
      data.accountOwnerName = data.cardOwnerName;
      data.cardNumber = data.cardNumber.split(" ").join("").split("-").join("");
      console.log(data, " asdasda ", _.size(data.cardNumber));
      if (_.size(data.cardNumber) < 16) {
        SwalMessage({
          title: "شماره کارت باید 16 رقم باشد",
          iSsuccess: false,
          timer: 5000,
        });
        return;
      }

      var rest = await ApiAccount.createAccount(data).then((responce) => {
        SwalMessage({
          title: responce.message,
          iSsuccess: responce.succeeded,
          timer: 5000,
        });
        handleClose();
        document.getElementById("submitButton").click();
      });
    } catch (error) {
      console.log("error=", error);
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalAccount} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>درج اطلاعات حساب</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs={12} className="text-center">
              <Col xs="12">
                <Controller
                  name="bank"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام بانک"
                      margin="normal"
                      variant="outlined"
                      className="form-control mb-2 "
                      size="small"
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.bank?.type === "required" && (
                  <span className="text-danger">
                    نام بانک نمیتواند خالی باشد
                  </span>
                )}
              </Col>
              <Col xs="12">
                <Controller
                  name="accountNumber"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره حساب"
                      margin="normal"
                      variant="outlined"
                      className="form-control mb-2 ltr "
                      size="small"
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.accountNumber?.type === "required" && (
                  <span className="text-danger">
                    شماره حساب نمیتواند خالی باشد
                  </span>
                )}
              </Col>
              <Col xs="12">
                <Controller
                  name="cardOwnerName"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام صاحب کارت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      className="mb-2 "
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                />
                {errors.cardOwnerName?.type === "required" && (
                  <span className="text-danger">
                    نام صاحب حساب نمیتواند خالی باشد
                  </span>
                )}
              </Col>
              <Col xs="12">
                <Controller
                  name="cardNumber"
                  rules={{ required: true }}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <>
                      <PatternFormat
                        format="#### - #### - #### - ####"
                        mask=""
                        type="text"
                        name="cardNumber"
                        className="mb-2 mt-5 ltr w-100"
                        label="شماره کارت"
                        variant="outlined"
                        value={value || ""}
                        onChange={onChange}
                        customInput={TextField}
                      />
                    </>
                  )}
                />
                {/* <Controller
                  name="cardNumber"
                  rules={{ required: true }}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <NumericFormat
                      format="#### - #### - #### - ####"
                      mask=""
                      type="text"
                      name="cardNumber"
                      className="mb-2 ltr"
                      placeholder="شماره کارت"
                      value={value || ""}
                      onChange={onChange}
                    />
                  )}
                /> */}
                {errors.cardNumber?.type === "required" && (
                  <span className="text-danger">
                    شماره کارت نمیتواند خالی باشد
                  </span>
                )}
                {/* {errors.cardNumber?.type === 'minLength' && <span>شماره کارت باید 16 رقم باشد</span>}  */}
              </Col>
              <Col xs="12">
                <Controller
                  name="shebaNumber"
                  rules={{ required: true, maxLength: 24, minLength: 24 }}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      type="number"
                      label="شماره شبا"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onChange={onChange}
                      className="form-control mb-2 ltr"
                      onKeyPress={(e) => {
                        if (e.target.value.length === 24) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                />
                {errors.shebaNumber?.type === "required" && (
                  <span className="text-danger">
                    شماره شبا نمیتواند خالی باشد
                  </span>
                )}
                {errors.shebaNumber?.type === "minLength" && (
                  <span className="text-danger">
                    {" "}
                    شماره شبا باید 24 کاراکتر باشد
                  </span>
                )}
              </Col>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ثبت شماره حساب
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
